import { Component, HostListener } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-budget-pdf-preview-modal',
  templateUrl: './budget-pdf-preview-modal.component.html',
  styleUrls: ['./budget-pdf-preview-modal.component.scss']
})
export class BudgetPdfPreviewModalComponent {

  /** PDF en base64 que el caller inyecta vía initialState al abrir el modal. */
  base64: string = '';

  constructor(private readonly bsModal: BsModalRef) { }

  /**
   * Detecta WebViews móviles (apps híbridas) que ya tienen su propia barra de
   * herramientas del sistema. En esos casos ocultamos los controles del visor
   * para evitar UI duplicada/superpuesta.
   */
  get isWebView(): boolean {
    const ua = navigator.userAgent;
    return /wv|WebView|ReactNative/i.test(ua) || (ua.includes('Version/') && ua.includes('Mobile'));
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.cancel();
  }

  cancel(): void {
    this.bsModal.hide();
  }
}
